import { FC } from 'react'
import { LayoutHeaderContainer, LayoutHeaderContent, LayoutHeaderIcon, LayoutHeaderWhiteContent } from '../layout.styled'
import { useBreakpoint } from '@yuno/sdk-web-core/dist/hooks'
import { queryClient } from '../../../state'
import { CheckoutInfo } from '../../../types'

const NO_IMAGE = 0

export const LayoutHeader: FC = () => {
  const { isMobile } = useBreakpoint()
  const checkoutInfo = queryClient.getQueryData<CheckoutInfo>(['checkout-info'])

  const image = checkoutInfo?.payment_link.merchant_image

  if (!image || image.replaceAll(' ', '').length === NO_IMAGE || image === null) {
    return null
  }

  return (
    <LayoutHeaderContainer>
      <LayoutHeaderContent>
        <LayoutHeaderIcon src={image} />
      </LayoutHeaderContent>
      {!isMobile && <LayoutHeaderWhiteContent />}
    </LayoutHeaderContainer>
  )
}
